/* Structural layout only — colors come from Astryx design tokens (resolved
   inside a <Theme> scope). */

/* auto-fit rather than a fixed column count: a fixed `repeat(4, 1fr)` left an
   empty 4th column whenever a page supplied fewer than four cards, so the row
   stopped short of the content width. auto-fit collapses the empty tracks, so
   three cards fill the row and four still lay out as four.
   200px is sized to the content column: four tracks plus three 16px gaps
   need 848px, which fits the 1152px available at the 1200px cap. */
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: var(--spacing-4);
}
